import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import NoOrganisationCard from 'components/v2/empty-state/NoOrganisationCard';
import PageLoader from 'components/spinners/PageLoader';
import { CompanyContext } from 'contexts/CompanyContextProvider';
import { ReactComponent as TeamIcon } from 'images/v2/icons/svg/fill/svg/team.svg';
import { withGreyBackground } from 'pages/v2/WithGreyBackground';
import { Container } from 'styles/Styles.styled';

const CompanyEmptyCard: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const { companyId } = useContext(CompanyContext);

  // companyId stays undefined until the company context resolves; showing the card earlier would flash it at users who do have an organisation.
  if (companyId === undefined) {
    return (
      <PageContainer>
        <PageLoader />
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <CompanyCard
        icon={<TeamIcon />}
        title={t('epdDashboard.userHasNoCompanies.startOrganisationPortalInfo')}
        descriptionLines={[
          t('epdDashboard.userHasNoCompanies.startOrganisationPortalInfo1'),
          t('epdDashboard.userHasNoCompanies.startOrganisationPortalInfo2'),
        ]}
      />
    </PageContainer>
  );
};

const PageContainer = styled(Container)`
  flex-wrap: nowrap;
  justify-content: center;
  margin-bottom: 0;
  min-height: calc(100vh - var(--billing-banner-height, 0px) - ${(props) => props.theme.variables.headerHeight});
  box-sizing: border-box;
  padding-top: 90px;
`;

const CompanyCard = styled(NoOrganisationCard)`
  height: auto;
  max-height: 515px;
`;

export default withGreyBackground(CompanyEmptyCard);
